const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

let url = location.href;

// preload
const preload = () =>{
  let timer = 0;
  $(window).on('load' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("preload");
    }, 100);
  });
};

// resizing
const resizing = () =>{
  let currentWidth = window.innerWidth;
  let timer = 0;
  $(window).on('resize' , function() {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    $("body").addClass("resizing");
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("resizing");
    }, 100);
  });
};

// リンクのアニメーション
const anchorScroll = () => {
  //URLのハッシュ値を取得
  var urlHash = location.hash;
  //ハッシュ値があればページ内スクロール
  if(urlHash) {
    //スクロールを0に戻す
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      //ロード時の処理を待ち、時間差でスクロール実行
      scrollToAnker(urlHash) ;
    }, 100);
  }

  //通常のクリック時
  $('a[href^="#"]').click(function() {
    //ページ内リンク先を取得
    var href= $(this).attr("href");
    //リンク先が#か空だったらhtmlに
    var hash = href == "#" || href == "" ? 'html' : href;
    //スクロール実行
    scrollToAnker(hash);
    //リンク無効化
    return false;
  });

  // 関数：スムーススクロール
  // 指定したアンカー(#ID)へアニメーションでスクロール
  function scrollToAnker(hash) {
    var target = $(hash);
    var position
    if(windowWidth > 1024){
      position = target.offset().top - 200;
    }else{
      position = target.offset().top - windowWidth * 0.234375;
    }
    $('body,html').stop().animate({scrollTop:position}, 500);
  }
}

// ヘッダーのスクロール
const headerScroll = () => {
  const target = $('.st-Header');
  $(window).scroll(function () {
    if ($(this).scrollTop() > target.height() * 1.5) {
      target.addClass('scrolled');
    } else {
      target.removeClass('scrolled');
      // let currentWidth = window.innerWidth;
      // if(currentWidth > 1199){
      //   target.removeClass('opened');
      // }
    }
  });
  $(window).on('load' , function() {
    $('.st-Header_Nav').addClass('is-loaded');
    if ($(this).scrollTop() > target.height()) {
      target.addClass('scrolled');
    } else {
      target.removeClass('scrolled');
    }
  });
};

// ヘッダーの開閉
const headerToggle = () => {
  //toggle
  const $header = $('.st-Header');
  const $body = $('body');
  const $headerTrigger = $('.st-Header_Button');
  $headerTrigger.on('click', function(){
    $header.toggleClass('opened');
    $body.toggleClass('showModal');
  });
};

// ページTOP
const backToTop = () =>{
  const topBtn = $('.sw-BackToTop');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//スクロールアニメーション
const scrollAnimation = () => {
  const controller = new ScrollMagic.Controller();
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene = new ScrollMagic.Scene({
      triggerElement: target,
      triggerHook: .9
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  const bg = $(".js-Background");
  const scene2 = new ScrollMagic.Scene({
    triggerElement: bg,
    duration: $('.st-Wrapper').innerHeight()
  })
  .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
      let p = prog.progress; // 0～1の値が入ってきます
      bg.css(
        'transform', 'translateY(' + -250 * p  + 'px)'
      );
  })
  .addTo(controller);
};

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.sw-Youtube');
  const $content = $('.sw-Youtube_Content');
  const $youtube = $('.js-Youtube');
  // open
  $youtube.on('click', function(){
    $(this).blur();
    const dataID = $(this).attr('data-youtube');
    //iframe append
    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
    // fadeIn
    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.sw-Youtube_Overlay,.sw-Youtube_Content,.sw-Youtube_Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children('iframe').remove();
    });
  });
};

//SVG展開
const deSvg = () => {
  window.addEventListener('load', function(){
    deSVG('.desvg', true);
  });
};



//export
export {preload, resizing, anchorScroll, headerScroll, headerToggle, backToTop, scrollAnimation, youtubeModal};



// WEBPACK FOOTER //
// ./src/vaas/assets/js/include/module.js